import { createStore } from '@ngneat/elf';
import { withEntities, selectAllEntities, setEntities, addEntities, updateEntities, deleteEntities } from '@ngneat/elf-entities';
import { SourceBibliographic } from '../core/models';


export const store = createStore({ name: 'sourceBib' }, withEntities<SourceBibliographic>());

export const sourceBib$ = store.pipe(selectAllEntities());

export function setSourceBib(sourceBib: SourceBibliographic[]) {
  store.update(setEntities(sourceBib));
}

export function addSourceBib(sourceBib: SourceBibliographic) {
  store.update(addEntities(sourceBib));
}

export function updateSourceBib(id: SourceBibliographic['id'], sourceBib: Partial<SourceBibliographic>) {
  store.update(updateEntities(id, sourceBib));
}

export function deleteSourceBib(id: SourceBibliographic['id']) {
  store.update(deleteEntities(id));
}
